<!--
   Created by qing on 2020/1/31 8:30 下午
   Des: 地图
-->
<template>
  <div class="statistics__map-container">
    <div
      class="statistics__map"
      ref="map">
    </div>
    <div class="indicator-container">
      <div
        class="indicator country"
        v-if="province.length"
        @click="goBackCountry">
        中国 >
      </div>
      <div class="indicator">
        {{province}}
      </div>
    </div>
  </div>
</template>

<script>

  import {clone} from "../../../../assets/js/Untis"
  import current from "./mixin"

  export default {
    mixins: [current],
    data() {
      return {
        chart: null,
        loaded: false,
        province: '',
        darwMapType: null,
        provinceData: null,
        optConf: {
          backgroundColor: '#FFFFFF',
          title: {
            text: '',
            subtext: '',
            x: 'center'
          },
          tooltip: {
            trigger: 'item'
          },
          visualMap: {
            type: 'continuous',
            min: 0,
            max: 800,
            calculable: true,
            inRange: {
              color: ['#D8E5B6', '#E22226']
            },
          },
          series: {
            name: '随机数据',
            type: 'map',
            mapType: '',
            roam: true,
            data: [],
          }
        },
      }
    },
    mounted() {
        if (this.$refs.map) {
          const chart = this.$ECharts.init(this.$refs.map)
          chart.title = ''
          this.chart = chart
          this.initChart('china', this.value)
        }

    },
    methods: {
      // 重新初始化图表 父级可调用
      initChart(darwMapType, data) {
        if (!this.chart && this.$refs.map) {
          const chart = this.$ECharts.init(this.$refs.map)
          chart.title = ''
          this.chart = chart
        }
        // 如果当前在二级地图中，即时没有传数据，也用当前数据,后期有三级地图后，也是这个逻辑
        if (this.darwMapType && this.provinceData && this.chart) {
          if (!darwMapType) darwMapType = this.darwMapType
          if (!data) data = this.provinceData || []
        } else {
          if (!darwMapType) darwMapType = 'china'
          if (!data) data = this.value || []
        }

        const opt = clone(this.optConf)

        opt.title.text = this.showPropertiesHolder.title
        opt.title.subtext = this.showPropertiesHolder.subTitle
        opt.tooltip.formatter = param => {
          if (!param.data) {
            return ''
          }
          return param.data.showName + '<br>' + this.chartPropertiesHolder.showFields[0].showName + ':' + param.value
        }
        // 设置最大值 最小值
        const valueArr = data.map(item => item.value)
        opt.visualMap.max = valueArr.length ? Math.max.apply(null, valueArr) : 1;
        opt.visualMap.min = valueArr.length ? Math.min.apply(null, valueArr) : 0;
        if (opt.visualMap.max === opt.visualMap.min) {
          opt.visualMap.min = 0
        }

        // 设置颜色
        opt.visualMap.inRange.color = this.showPropertiesHolder.color.value
        // 设置数据
        opt.series.mapType = darwMapType
        opt.series.data = data

        if (this.showPropertiesHolder.showDataTag) {
          opt.series.label = {
            show: true,
            formatter: param => {
              if (!param.data) {
                return ''
              }
              let formatter = ''
              if (this.showPropertiesHolder.showDimensionTag) {
                // 显示维度值
                formatter = param.data.showName || ''
              }
              if (this.showPropertiesHolder.showIndexTag) {
                // 显示指标值
                formatter += formatter.length ? '\n' + param.data.value : param.data.value
              }
              return formatter
            }
          }
        }

        this.chart.setOption(opt, true, false, true)
        this.resize()

        this.chart.off('click')
        this.chart.on("click", param => {
          if (param.data && param.data.children && param.data.children.length) {
            this.province = param.data.showName || ''
            this.darwMapType = param.name
            this.provinceData = param.data.children
            this.initChart(param.name, param.data.children)
          }
          this.showDataDrillDownList(param)
        });
      },
      // 返回完整国家地图
      goBackCountry() {
        this.province = ''
        this.darwMapType = null
        this.provinceData = null
        this.initChart()
      },
      // 重置或初始化图表实例
      resize() {
        this.$nextTick(() => {
          this.chart.resize()
        })
      }
    },
    watch: {
      // value 发生修改时 重新渲染图表
      value() {
        this.initChart('china', this.value)
      }
    }
  }
</script>

<style lang="less">
  .statistics__map-container {

    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;

    .statistics__map {
      width: 100%;
      flex: 1;
      background-color: #ffffff;
      position: relative;
    }

    .indicator-container {
      width: 100%;
      height: 60px;
      display: flex;
      justify-content: center;

      .country {
        cursor: pointer;
      }

      .indicator {
        margin-right: 20px;
        font-size: 14px;
        color: #959699;
      }
    }
  }
</style>
